import { type ReactNode } from 'react';
import { cn } from '@/lib/cn';

/** A keyboard key hint, e.g. `⌘K`. */
export function Kbd({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <kbd
      className={cn(
        'rounded border border-border bg-muted px-1 py-0.5 font-mono text-[10px] text-muted-foreground',
        className,
      )}
    >
      {children}
    </kbd>
  );
}
